import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import { useApp } from '../context/AppContext';

/**
 * Displays Pixie's next story chapter. Used inside the Pixie chatbot panel.
 */
export default function StoryChapter() {
  const { API, user } = useApp();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!user) return;
    const token = localStorage.getItem('pp-token') || '';
    axios.get(`${API}/story/chapter`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setData(r.data)).catch(() => setData(null));
  }, [user]);

  if (!user) {
    return (
      <div data-testid="story-chapter-locked" className="text-xs font-body-story italic text-[#68615A]">
        Sign in to unlock Pixie's tale
      </div>
    );
  }
  if (!data) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }}
      data-testid="story-chapter"
      className="rounded-xl border border-[#C9B99A] bg-[#FDF7E6] p-3">
      {data.current.image && (
        <img
          src={data.current.image}
          alt={data.current.title}
          data-testid="story-chapter-image"
          className="w-full h-32 object-cover rounded-lg mb-2 border border-[#C9B99A]"
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
      )}
      <div className="flex items-center gap-2 mb-1">
        <BookOpen size={14} className="text-[#8C1C13]" />
        <div className="font-storybook text-sm text-[#2C2621]">
          Chapter {data.current.n}: {data.current.title}
        </div>
      </div>
      <div data-testid="story-chapter-text" className="font-body-story text-xs text-[#4A413A] leading-relaxed">
        {data.current.text}
      </div>
      {data.next_title ? (
        <div data-testid="story-next" className="mt-2 pt-2 border-t border-[#C9B99A]/60 text-[10px] font-body-story italic text-[#68615A]">
          Next: <b>{data.next_title}</b> unlocks at {data.next_unlock_at} completed quests
          ({Math.max(0, data.next_unlock_at - data.completed_quests)} to go)
        </div>
      ) : (
        <div className="mt-2 text-[10px] font-body-story italic text-[#2B5329]">
          All chapters unlocked — you are legend.
        </div>
      )}
    </motion.div>
  );
}
